/*
FMC
Integration: https://acquire1dev.alldata.net
UAT: https://acquire1uat.comenity.net
Production: https://acquire1.comenity.net
* */
import { PluginConfig } from './plugin.model';
import { apiHostEnv, fmcApiBaseUrlEnv, hostEnv, HostEnv } from '../constants/env-config.const';

export class EpJsConfig {
  host: string;
  loggingEnabled: boolean;
  apiKey: string;
  apiHost: string;
  sdkVersion: string;
  disableCache: boolean;
  analyticsUrl: string;
  enableAnalytics = true;
  onReady: () => void;
  fmcApiBaseUrl: string;
  plugins: PluginConfig;
  env: string;

  constructor(config: Partial<EpJsConfig> = {}) {
    this.env = config.env || 'PROD';
    this.env = this.env.toUpperCase();

    this.host = config.host || hostEnv[this.env];
    this.disableCache = config.disableCache || false;
    this.loggingEnabled = config.loggingEnabled || false;
    this.fmcApiBaseUrl = config.fmcApiBaseUrl || fmcApiBaseUrlEnv[this.env];
    this.apiKey = config.apiKey;
    this.apiHost = config.apiHost || apiHostEnv[HostEnv.Prod];
    this.analyticsUrl = config.analyticsUrl || 'https://metrics.kmsmep.com/ep';
    this.sdkVersion = config.sdkVersion || 'DEV';
    this.plugins = new PluginConfig(config.plugins);


    if (config.enableAnalytics !== undefined) {
      this.enableAnalytics = config.enableAnalytics;
    }else if(this.env !== HostEnv.Prod){
      this.enableAnalytics = false;
    }

    if (config.onReady !== undefined) {
      this.onReady = config.onReady;
    }
  }
}
